var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"bottomSlide","appear":""}},[_c('div',{staticClass:"footerModal"},[_c('CloseIcon',{staticClass:"footerModal__close",attrs:{"color":"#656D78"},nativeOn:{"click":function($event){_vm.$emit('close')}}}),_vm._v(" "),_c('listMenu',{attrs:{"menu-list":_vm.menuList,"fontColor":"#434A54","iconColor":"#FF7497","headColor":"#FF7497","padding":"20px 20px 0px"}})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df4bf672","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/common/FooterModal.vue
// module id = null
// module chunks = 